// This file contains functions that help translate values / concepts returned by
// the "web3 connector libraries" to values that are understood by the Crypto
// Payins implementation

import {SupportedAsset} from 'src/types';
import {SupportedCurrency} from 'src/v2/state/types';
import {Abi} from 'viem';
import {Tip20Abi} from 'src/abi/Tip20Abi';
import {UsdcAbi} from 'src/abi/UsdcAbi';
import {UsdtAbi} from 'src/abi/UsdtAbi';
import {UsdpAbi} from 'src/abi/UsdpAbi';
import {UsdgAbi} from 'src/abi/UsdgAbi';

export const getAbiForAsset = (
  asset: SupportedAsset | SupportedCurrency,
): Abi => {
  switch (asset.id) {
    case 'usdc.ethereum':
    case 'usdc.polygon':
    case 'usdc.base':
      return UsdcAbi;
    case 'usdt.ethereum':
      return UsdtAbi as Abi;
    case 'usdp.ethereum':
      // TODO: USDP ABI is mising transferWithAuthorization, so gasless won't work until that's updated
      return UsdpAbi;
    case 'usdg.ethereum':
      return UsdgAbi as Abi;
    case 'usdc.tempo':
      return Tip20Abi;
    default:
      throw new Error(`Unsupported asset: ${asset.id}`);
  }
};
